export default __webpack_public_path__ + "static/media/tren-persentase.ffe2cdda.png";